import { createContext, PropsWithChildren, useState } from "react";
import { PublicUser } from "../../shared/types";

export interface UserContextValue {
  user?: PublicUser;
  setUser: (user: PublicUser | undefined) => void;
}

//@ts-ignore
export const UserContext = createContext<UserContextValue>({});

interface Props extends PropsWithChildren {
  initialUser?: PublicUser;
}

export const UserContextProvider: React.FC<Props> = ({
  initialUser,
  children,
}) => {
  const [_user, setUser] = useState<PublicUser | undefined>(initialUser);

  return (
    <UserContext.Provider
      value={{
        user: _user,
        setUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
